import type { AccountRelatedRow } from '~/services/ContractingService';

import type { AccountContact } from './types';

export function toAccountContact(row: AccountRelatedRow<'contacts'>): AccountContact {
  return {
    id: row.external_refs.salesforce,
    name: row.name,
    title: row.title,
    email: row.email,
    mobilePhone: row.mobile_phone,
    phone: row.phone,
  };
}
